<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="app">
    <scroll class="bg-white" @refresh="refresh">
      <div class="hos-info-image">
        <img :src="hospitalImage" v-show="hospitalInfo.image != ''" />
      </div>

      <div class="hos-info-name">
        <h3 style="text-align: left; margin: 0">
          {{ hospitalName }}
        </h3>
      </div>
      <div class="text-dsc">{{ hospitalInfo.desc }}</div>
    </scroll>
  </div>
</template>

<script>
import hospitals from 'hospital.service'
export default {
  data () {
    return {
      hospitalInfo: {},
      hospitalName: "",
      hospitalImage: ""
    }
  },
  mounted () {
    this.refresh();
  },
  methods: {
    refresh () {
      hospitals.getHosInfo().then((res) => {
        this.hospitalInfo = res
        this.hospitalImage = res.image + '?t=' + Math.random();
      })
      var selectHospital = localStorage.selectedHospital;
      this.hospitalName = selectHospital ? JSON.parse(selectHospital).hospitalName : "";
    }
  }
}
</script>
<style lang="scss" scoped >
@import "../../../static/sass/_variable.scss";
.hos-info-name {
  border-bottom: 1px solid #d7d7d7;
  padding: 0.5rem 0;
  margin: 0 0.5rem;
}
.hos-info-image {
  padding: 0.5rem;
  img {
    width: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// HosInfo.vue?b0258982